import { MAX_QUANTITY_LIMIT } from '../constants.js';

const getMaxSelectableQuantity = ({ availableQuantity , maxOrderableQuantity , allowBackOrder  })=>{
    if (!allowBackOrder) {
        /**
     * Negative stock can happen if multiple users happen to order the last product at the same time.
     * On the FE, though, treat it as zero stock.
     */ if (availableQuantity && availableQuantity < 0) {
            return 0;
        }
        if (maxOrderableQuantity && availableQuantity) {
            return maxOrderableQuantity > availableQuantity ? availableQuantity : maxOrderableQuantity;
        }
        if (availableQuantity !== undefined) {
            return availableQuantity;
        }
    }
    if (maxOrderableQuantity) {
        return maxOrderableQuantity;
    }
    return MAX_QUANTITY_LIMIT;
};

export { getMaxSelectableQuantity };
//# sourceMappingURL=get-max-selectable-quantity.js.map
